/* eslint-ignore */
// @ts-nocheck
import React, { Component } from 'react';
import styled from 'styled-components';

const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  max-width: 100%;
  height: 400px;
  margin: 0 auto;
  margin-top: 2vh;
  border-radius: 20px;
  align-items: center;
  justify-content: center;
`;

const ErrorIconContainer = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SuccessTitle = styled.span`
  font-size: 1.5625rem;
  font-weight: 700;
  text-align: center;
  color: #005ca5;
  margin-top: 10px;
  @media (max-width: 370px) {
    font-size: 1.4375rem;
  }
`;

const ErrorIcon = styled.span`
  font-size: 3.4375rem;
  margin-top: -35.5px;
  color: #f0b01b;
`;

const SuccessText = styled.span`
  color: #808495;
  text-align: center;
  margin-top: 15px;
  font-size: 1rem;
  padding: 0px 30px 0px 30px;
  @media (max-width: 370px) {
    font-size: 0.9375rem;
    padding: 0;
  }
`;

const UacContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  margin-top: 20px;
  @media (max-width: 350px) {
    flex-direction: column;
  }
`;

const UacItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const UacDescription = styled.span`
  font-size: 0.9375rem;
  color: #005ca5;
  text-align: center;
`;

const UacPhone = styled.span`
  font-size: 0.875rem;
  color: #9fa2af;
`;

const OpeningHoursContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
`;

const OpeningHours = styled.span`
  color: #808495;
  text-align: center;
  font-size: 1rem;
  padding: 0px 30px 0px 30px;
  @media (max-width: 370px) {
    font-size: 0.9375rem;
    padding: 0;
  }
`;

export default class Steps extends Component {
  render() {
    return (
      <SuccessContainer>
        <SuccessTitle>Ops! Parece que algo não deu certo.</SuccessTitle>
        <SuccessText>
          Converse com os nossos especialistas pelo Chat On-line.
          <br />
          Nosso time está conectado 24 horas por dia e 7 dias da semana para
          melhor atendê-lo
        </SuccessText>
      </SuccessContainer>
    );
  }
}
